// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__20i4R","errors":"Errors_errors__3gT8Z"};